export default "__VITE_ASSET__YKWSgwAI__"